<div class="row align-items-center mb-4 g-2">
    <!-- Search Section -->
    <div [class]="searchColClass()">
        <div class="row g-2 align-items-end">
            <ng-content select="[slot=search]"></ng-content>
        </div>
    </div>

    <!-- Actions Section -->
    <div [class]="actionsColClass()">
        <div class="d-flex justify-content-end align-items-center gap-2">
            <ng-content select="[slot=filters]"></ng-content>
            <ng-content select="[slot=actions]"></ng-content>
        </div>
    </div>
</div>
